import { Modal } from '@mantine/core';

import ProjectPermissions from '@projects/components/ProjectPermissions/ProjectPermissions';
import Project from 'src/entities/project';
import useDelayedOpening from 'src/new_arch/hooks/useDelayedOpening';
import useStackeableModal from 'src/new_arch/hooks/useStackeableModal';

export type ManageReviewerRoleModalProps = {
	project: Project;
	onClose: () => void;
	stackOrder?: number;
	viewOnlyWithDownloads?: boolean;
	onViewOnlyWithDownloadsChange?: ( enabled: boolean ) => void;
};

const MODAL_STYLES = {
	content: { backgroundColor: 'var(--color-bg-container)' },
	header: {
		borderBottom: '1px solid var(--color-outline-light)',
		backgroundColor: 'var(--color-bg-container)'
	},
	title: { color: 'var(--color-text-primary)' },
	close: { color: 'var(--color-text-primary)' },
	body: { backgroundColor: 'var(--color-bg-container)', padding: '16px 0' }
};

const ManageReviewerRoleModal = ( {
	project,
	onClose,
	stackOrder = 1,
	viewOnlyWithDownloads,
	onViewOnlyWithDownloadsChange
}: ManageReviewerRoleModalProps ) => {
	const opened = useDelayedOpening();
	const {
		modalStyles, submodalsStackOrder
	} = useStackeableModal( { stackOrder, defaultStyles: MODAL_STYLES } );

	return (
		<Modal
			opened={opened}
			onClose={onClose}
			size={500}
			title="Customize Permissions"
			closeButtonProps={{ size: 24 }}
			className="ManageReviewerRoleModal"
			styles={modalStyles}
			centered
		>
			<ProjectPermissions
				project={project}
				modalsStackOrder={submodalsStackOrder}
				viewOnlyWithDownloads={viewOnlyWithDownloads}
				onViewOnlyWithDownloadsChange={onViewOnlyWithDownloadsChange}
			/>
		</Modal>
	);
};

export default ManageReviewerRoleModal;
